import { render, staticRenderFns } from "./address_list.vue?vue&type=template&id=8443e1b0&scoped=true"
import script from "./address_list.vue?vue&type=script&lang=js"
export * from "./address_list.vue?vue&type=script&lang=js"
import style0 from "./address_list.vue?vue&type=style&index=0&id=8443e1b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8443e1b0",
  null
  
)

export default component.exports